import type { ProductCard } from "@convex/products/validators.lib";
import type { DiscoveryProduct } from "@/components/discovery/types";

export function toDiscoveryProduct(listing: ProductCard): DiscoveryProduct {
  return {
    ...listing,
    distance: 0,
    pickupAddressCity: null,
    pickupAddressState: null,
    pickupAddressZip: null,
  };
}

type BrowseListingField =
  | "_id"
  | "title"
  | "slug"
  | "publicIdentifier"
  | "productTypeSlug"
  | "buyerUnitPriceCents"
  | "primaryImageUrl"
  | "cityName"
  | "stateAbbr"
  | "cityLatitude"
  | "cityLongitude"
  | "originZip"
  | "checkoutEnabled"
  | "intent"
  | "condition"
  | "availableToSell"
  | "shippingMethods"
  | "dimensions"
  | "specs"
  | "minOrderQuantity"
  | "minCheckoutQuantity";

export type BrowseListing = Pick<ProductCard, BrowseListingField> & {
  productType: { displayName: string } | null;
  distance?: number;
};

export function toBrowseListing(listing: BrowseListing): BrowseListing {
  return {
    _id: listing._id,
    title: listing.title,
    slug: listing.slug,
    publicIdentifier: listing.publicIdentifier,
    productTypeSlug: listing.productTypeSlug,
    buyerUnitPriceCents: listing.buyerUnitPriceCents,
    primaryImageUrl: listing.primaryImageUrl,
    cityName: listing.cityName,
    stateAbbr: listing.stateAbbr,
    cityLatitude: listing.cityLatitude,
    cityLongitude: listing.cityLongitude,
    originZip: listing.originZip,
    checkoutEnabled: listing.checkoutEnabled,
    intent: listing.intent,
    condition: listing.condition,
    availableToSell: listing.availableToSell,
    shippingMethods: listing.shippingMethods,
    dimensions: listing.dimensions,
    specs: listing.specs,
    minOrderQuantity: listing.minOrderQuantity,
    minCheckoutQuantity: listing.minCheckoutQuantity,
    productType: listing.productType ? { displayName: listing.productType.displayName } : null,
  };
}
